"use strict";
/**
 * BEST2 Result Operations
 *
 * Collects job results emitted by ERG* opcodes.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultCollector = void 0;
exports.ergb = ergb;
exports.ergw = ergw;
exports.ergd = ergd;
exports.ergi = ergi;
exports.ergiValue = ergiValue;
exports.ergr = ergr;
exports.ergs = ergs;
exports.ergy = ergy;
exports.ergc = ergc;
exports.ergl = ergl;
const register_values_1 = require("./register-values");
function stripNullTerminator(value) {
    return value.replace(/\0.*$/, "");
}
function normalizeKey(name) {
    return name.toUpperCase();
}
function cloneValue(value) {
    if (value instanceof Uint8Array) {
        return new Uint8Array(value);
    }
    return value;
}
class ResultCollector {
    results = new Map();
    add(result) {
        const key = normalizeKey(result.name);
        const stored = {
            name: result.name,
            type: result.type,
            value: cloneValue(result.value),
        };
        if (result.unit !== undefined) {
            stored.unit = result.unit;
        }
        if (result.comment !== undefined) {
            stored.comment = result.comment;
        }
        this.results.set(key, stored);
    }
    record(name, type, value, unit, comment) {
        this.add({ name, type, value, unit, comment });
    }
    get(name) {
        return this.results.get(normalizeKey(name));
    }
    has(name) {
        return this.results.has(normalizeKey(name));
    }
    clear() {
        this.results.clear();
    }
    list() {
        return Array.from(this.results.values());
    }
    get size() {
        return this.results.size;
    }
}
exports.ResultCollector = ResultCollector;
function resolveString(registers, source) {
    if (typeof source === "string") {
        return stripNullTerminator(source);
    }
    return stripNullTerminator((0, register_values_1.getStringValue)(registers, source));
}
function maskUnsigned(value, bits) {
    const unsigned = value >>> 0;
    switch (bits) {
        case 8:
            return unsigned & 0xff;
        case 16:
            return unsigned & 0xffff;
        case 32:
            return unsigned >>> 0;
    }
}
function toSigned8(value) {
    const masked = maskUnsigned(value, 8);
    if ((masked & 0x80) !== 0) {
        return masked - 0x100;
    }
    return masked;
}
function toSigned16(value) {
    const masked = maskUnsigned(value, 16);
    if ((masked & 0x8000) !== 0) {
        return masked - 0x10000;
    }
    return masked;
}
function toSigned32(value) {
    const masked = maskUnsigned(value, 32);
    if ((masked & 0x80000000) !== 0) {
        return masked - 0x1_0000_0000;
    }
    return masked;
}
function ergb(registers, collector, name, value) {
    const resultName = resolveString(registers, name);
    const raw = typeof value === "number" ? value : (0, register_values_1.getIntValue)(registers, value);
    collector.record(resultName, "byte", maskUnsigned(raw, 8));
}
function ergw(registers, collector, name, value) {
    const resultName = resolveString(registers, name);
    const raw = typeof value === "number" ? value : (0, register_values_1.getIntValue)(registers, value);
    collector.record(resultName, "word", maskUnsigned(raw, 16));
}
function ergd(registers, collector, name, value) {
    const resultName = resolveString(registers, name);
    const raw = typeof value === "number" ? value : (0, register_values_1.getIntValue)(registers, value);
    collector.record(resultName, "dword", maskUnsigned(raw, 32));
}
function ergi(registers, collector, name, value) {
    const resultName = resolveString(registers, name);
    const raw = typeof value === "number" ? value : (0, register_values_1.getIntValue)(registers, value);
    collector.record(resultName, "int", toSigned16(raw));
}
/**
 * ergi variant that takes a resolved value directly (for immediate operands)
 */
function ergiValue(collector, name, value) {
    collector.record(name, "int", toSigned16(value));
}
function ergr(registers, collector, name, value) {
    const resultName = resolveString(registers, name);
    const raw = (0, register_values_1.getFloatValue)(registers, value);
    collector.record(resultName, "real", raw);
}
function ergs(registers, collector, name, value) {
    const resultName = resolveString(registers, name);
    const raw = resolveString(registers, value);
    const clean = raw.replace(/\0.*$/, "");
    collector.record(resultName, "string", clean);
}
function ergy(registers, collector, name, value) {
    const resultName = resolveString(registers, name);
    collector.record(resultName, "binary", value);
}
function ergc(registers, collector, name, value) {
    const resultName = resolveString(registers, name);
    const raw = typeof value === "number" ? value : (0, register_values_1.getIntValue)(registers, value);
    collector.record(resultName, "char", toSigned8(raw));
}
function ergl(registers, collector, name, value) {
    const resultName = resolveString(registers, name);
    const raw = typeof value === "number" ? value : (0, register_values_1.getIntValue)(registers, value);
    collector.record(resultName, "long", toSigned32(raw));
}
//# sourceMappingURL=result.js.map